__turbopack_context__.v({
  "close-panel": "MO_n4a_close-panel",
  "modal": "MO_n4a_modal",
  "modal-body": "MO_n4a_modal-body",
  "modal-content": "MO_n4a_modal-content",
});
